import { Link } from 'react-router-dom';

const Academics = () => {
  return (
    <>
      <section className="bg-gradient-to-r from-primary to-primary-600 text-white py-20 text-center">
        <div className="container">
          <h1 className="text-5xl font-bold mb-4">Academics</h1>
          <p className="text-xl max-w-2xl mx-auto">Comprehensive Islamic and Modern Curriculum</p>
        </div>
      </section>
      
      <section className="py-24">
        <div className="container">
          <div className="grid lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-3xl p-10 shadow-xl border border-slate-100">
              <i className="fas fa-book text-5xl text-primary mb-6"></i>
              <h3 className="text-2xl font-bold mb-4">Islamic Studies</h3>
              <p className="text-slate-600">Quran, Hadith, Fiqh, Arabic - foundation of faith</p>
            </div>
            <div className="bg-white rounded-3xl p-10 shadow-xl border border-slate-100">
              <i className="fas fa-calculator text-5xl text-primary mb-6"></i>
              <h3 className="text-2xl font-bold mb-4">Mathematics & Sciences</h3>
              <p className="text-slate-600">Rigorous STEM curriculum with practical applications</p>
            </div>
            <div className="bg-white rounded-3xl p-10 shadow-xl border border-slate-100">
              <i className="fas fa-globe text-5xl text-primary mb-6"></i>
              <h3 className="text-2xl font-bold mb-4">Languages & Arts</h3>
              <p className="text-slate-600">English, Literature, Creative Arts, Computer Skills</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-slate-50">
        <div className="container text-center">
          <h2 className="text-3xl font-bold text-slate-900 mb-6">Ready to Join?</h2>
          <p className="text-xl text-slate-600 mb-8 max-w-2xl mx-auto">Start your journey with us today. Registration is open for the new academic session.</p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/auth/student-register" className="bg-gradient-to-r from-primary to-primary-600 text-white px-10 py-4 rounded-2xl font-bold text-lg shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all inline-flex items-center gap-3">
              <i className="fas fa-user-plus"></i> Register Now
            </Link>
            <Link to="/contact" className="border-2 border-primary text-primary hover:bg-primary hover:text-white px-10 py-4 rounded-2xl font-bold text-lg shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all inline-flex items-center gap-3">
              <i className="fas fa-envelope"></i> Contact Us
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Academics;

